import { InputHTMLAttributes } from "react";
import { useFormContext, Controller } from 'react-hook-form';
import Label from "../label";

interface TextareaWithCounterProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    maxLength?: number;
    value?: string;
    placeholder?: string;
    rows?: number;
    label?: string;
    className?: string;
    control?: any;
    name?: string;
}

export default function TextAreaCounter({
    maxLength = 200,
    value = "",
    placeholder = "Type your message...",
    rows = 4,
    label,
    className = "",
    onChange,
    disabled,
    name,
    ...others
}: TextareaWithCounterProps) {
    const formContext = useFormContext();
    const control = formContext?.control || others?.control;

    if (!control) {
        // If not using react-hook-form, fallback to controlled textarea
        return (
            <div className={`flex flex-col w-full ${className}`}>
                {label && <Label label={label} />}
                <div className="rounded-basicRadius shadow-shadowAll text-sm bg-white border border-feildBorder flex rounded-md w-full flex-col flex-wrap mb-2 p-2">
                    <textarea
                        value={value}
                        onChange={onChange}
                        maxLength={maxLength}
                        rows={rows}
                        className={`input input-md h-[${rows}rem] p-0 bg-white border-0 font-aeonikReg resize-none focus:outline-transparent text-sm`}
                        placeholder={placeholder}
                        disabled={disabled}
                        {...others}
                    ></textarea>
                    <div className="text-right text-[0.625rem] text-newGreyCol mt-1">
                        {value?.length || 0}-{maxLength}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Controller
            name={name || ""}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <div className={`flex flex-col w-full ${className}`}>
                    {label && <Label label={label} />}
                    <div className="rounded-basicRadius shadow-shadowAll text-sm bg-white border border-feildBorder flex rounded-md w-full flex-col flex-wrap mb-2 p-2">
                        <textarea
                            {...field}
                            maxLength={maxLength}
                            rows={rows}
                            className={`input input-md h-[${rows}rem] p-0 bg-white border-0 font-aeonikReg resize-none focus:outline-transparent text-sm`}
                            placeholder={placeholder}
                            disabled={disabled}
                            {...others}
                        ></textarea>
                        <div className="text-right text-[0.625rem] text-newGreyCol mt-1">
                            {field.value?.length || 0}-{maxLength}
                        </div>
                    </div>
                    {error && <span className="text-sm text-rejectDark">{error.message}</span>}
                </div>
            )}
        />
    );
}
